import React, { useState, useEffect } from 'react';
import { Flex, Input, Modal, List } from 'antd';
import { SwapOutlined, AppstoreAddOutlined } from '@ant-design/icons';
import { safeNavigate, SafeStorage } from '../../utils/webview';

// const shops = [{shopId: 1, title: '杭州店'}, {shopId: 2, title: '长沙店'}]
const accId = window.__baseInfo.accId;

const SwitchShop = (props) => {
    const [shops, setShops] = React.useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const { title = '', onSwitch, children } = props;
    // 初始店铺获取逻辑 
    const [currentShop, setCurrentShop] = useState(null);

    // 初始化时获取当前店铺信息
    useEffect(() => {
        const initCurrentShop = async () => {
            try {
                // 次选localStorage数据 
                let storedShop = await SafeStorage.getItem('currentShop');
                // const defaultShop = { id: '001', title: '默认店铺' };
                storedShop = storedShop ? JSON.parse(storedShop)[accId] : null;
                console.log('storedShop', storedShop);
                setCurrentShop(storedShop);
                
                // 如果没有店铺信息，打开选择店铺对话框
                if (!storedShop) setIsOpen(true);
            } catch (error) {
                console.log(error);
                setIsOpen(true);
            }
        };
        
        initCurrentShop();
    }, []);

    // 同步状态与参数 
    useEffect(() => {
        getShops();
    }, []);

    const getShops = async () => {
        let response = await fetch(`/api/shop/my-permission-list?accId=${accId}`);
        let result = await response.json();

        if(result && result.success) {
            setShops(result.data);
            SwitchShop.shops = result.data;
        }
    }

    const switchShop =  () => {
        console.log('切换店铺');

        setIsOpen(true);
    }

    // 店铺切换处理器 
    const handleShopSwitch = async (shop) => {
        // 更新URL参数 
        const newUrl = new URL(window.location.href); 
        newUrl.searchParams.set('shopId',  shop.shopId); 
        
        // 写入存储并刷新 
        await SafeStorage.setItem('currentShop',  JSON.stringify({[accId]: shop})); 
        setCurrentShop(shop);
        // window.location.href  = newUrl.toString(); 
        // window.history.pushState({}, '', newUrl.toString());
        // 触发事件
        window.dispatchEvent(new Event('shopSwitch'));
        // setIsOpen(false);

        // if(onSwitch) {
        //     onSwitch(shop);
        // } else {
        //     window.location.href = newUrl.toString();
        // }
        safeNavigate(newUrl.toString());
    };

    return (
        <Flex justify="space-between" align="center" 
            style={{padding: '0 8px', background: 'rgb(245 245 245)', border: '1px solid rgb(230 230 230)', borderRadius: 2}}>
            <Modal title='请选择店铺' open={isOpen} footer={null} centered onCancel={() => setIsOpen(false)}>
                <div style={{ height: '50vh', overflow: 'auto'}}>
                    <Input.Search placeholder='搜索店铺名' />
                    <List
                        // header={<div>Header</div>}
                        // footer={<div>Footer</div>}
                        // bordered
                        dataSource={shops}
                        renderItem={(item) => <List.Item actions={[<a>选择</a>]} onClick={() => handleShopSwitch(item)} key={item.shopId}>{item.title}</List.Item>}
                    />
                </div>
            </Modal>
            <div style={{font: '14px/24px bold', padding: '6px 0'}}>{currentShop && (currentShop.title || '未选择店铺')}</div>
            <div onClick={switchShop}>{children ? children : <a><SwapOutlined  /> 切换店铺</a>}</div>
        </Flex>
    )
}

export default SwitchShop;